/**
 * Who the editor is signed in as, for the account dropdown: a backend may log
 * them back in silently. Undefined when neither a name nor an email is known.
 */
export function selectUserIdentity(user) {
  if (!user) {
    return undefined;
  }
  const label = user.name || user.login || user.email;
  if (!label) {
    return undefined;
  }
  return {
    label,
    ...(user.email && user.email !== label && {
      email: user.email
    })
  };
}